export const TEST = 'data-test';
export const GTM_CLICK = 'data-gtm-click';
export const MYB_CLICK = 'data-myb-click';
export const DATA_ATTRS = 'dataAttrs';
